import type { DocV2 } from './doc.entity.js';

export enum DocumentListDownloadColumn {
  Id = 'ID',
  Filename = 'Filename',
  FileType = 'File Type',
  UploadDate = 'Upload Date',
  Author = 'Author',
  Date = 'Date',
  DocumentType = 'Document Type',
  Summary = 'Summary',
  NumberOfPages = 'Number Of Pages',
  NumberOfFacts = 'Number Of Facts',
  NumberOfKeyFacts = 'Number Of Key Facts',
  NumberOfRelevantFacts = 'Number Of Relevant Facts',
  Issues = 'Issues',
}

export function prepareDocumentDownloadRow(
  document: DocV2 & { relevantFactsCount: number; keyFactsCount: number },
  columns: DocumentListDownloadColumn[],
  relativityColumns: string[] = [],
): string[] {
  const columnMapping: Record<DocumentListDownloadColumn, string | Date | null | undefined> = {
    [DocumentListDownloadColumn.Id]: document.id,
    [DocumentListDownloadColumn.Filename]: document.file.name,
    [DocumentListDownloadColumn.FileType]: document.file.extension,
    [DocumentListDownloadColumn.UploadDate]: document.createdDate,
    [DocumentListDownloadColumn.Author]: document.author,
    [DocumentListDownloadColumn.Date]: document.date,
    [DocumentListDownloadColumn.DocumentType]: document.type,
    [DocumentListDownloadColumn.Summary]: document.summary,
    [DocumentListDownloadColumn.NumberOfPages]: document.file.numberOfPages?.toString() ?? '',
    [DocumentListDownloadColumn.NumberOfFacts]: document.factsCount.toString(),
    [DocumentListDownloadColumn.NumberOfKeyFacts]: document.keyFactsCount.toString(),
    [DocumentListDownloadColumn.NumberOfRelevantFacts]: document.relevantFactsCount.toString(),
    [DocumentListDownloadColumn.Issues]: document.issues.join(', '),
  };

  const standardValues = columns.map((column) => columnMapping[column]?.toString() ?? '');

  const relativityValues = relativityColumns.map((fieldKey) => {
    const value = document.file.fileMetadata?.relativityFields[fieldKey];
    if (value === null || value === undefined) return '';
    if (Array.isArray(value)) return value.join('; ');
    return value.toString();
  });

  return [...standardValues, ...relativityValues];
}
